import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=3140a04c&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=ts&"
export * from "./MainNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=3140a04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140a04c",
  null
  
)

export default component.exports